<template>
    <div>
        <b-dropdown id="dropdown-1"  variant="outline-success" class="p-0" text="Dropdown Button" no-caret >
            <template  v-slot:button-content>
                <a href="#" class="header-icon" data-toggle="dropdown" title="You got 11 notifications">
                    <i class="fal fa-bell"></i>

                </a>
            </template>

            <b-dropdown-form class="notif_user">
                <div class=" dropdown-xl">
                    <div class="dropdown-header bg-trans-gradient d-flex justify-content-center align-items-center rounded-top mb-2">
                        <h4 class="m-0 text-center color-white">
                            Повідомлення
                        </h4>
                    </div>
                    <ul class="nav nav-tabs nav-tabs-clean" role="tablist">
                        <li class="nav-item" v-for="tab in tabs">
                            <a class="nav-link px-4 fs-md js-waves-on fw-400" data-toggle="tab" v-on:click="activate_tab(tab)" >
                               {{tab.name}}
                            </a>
                        </li>
                    </ul>

                    <div class="tab-content tab-notification">
                        <div class="tab-pane p-3 text-center" v-if="is_active_empty" :class="{'active' : is_active_empty}">
                            <h5 class="mt-4 pt-4 fw-500">
                                <span class="d-block fa-3x pb-4 text-muted">
                                    <i class="ni ni-arrow-up text-gradient opacity-70"></i>
                                </span>Оберіть таб для відображення
                                <small class="mt-3 fs-b fw-400 text-muted">
                                    Тут Ви маєте можливість переглянути Дні народження співробітників поточно місяця, та переглянути повідомлення
                                </small>
                            </h5>
                        </div>

                        <div class="tab-pane" id="tab-messages" role="tabpanel" v-if="!is_active_empty" :class="{'active' : !is_active_empty}">
                            <message v-if="active_tab.type == 'message'"></message>
                            <feed v-if="active_tab.type == 'feed'"></feed>
                            <birthday v-if="active_tab.type == 'birthday'"></birthday>
                        </div>
                    </div>

                    <div class="py-2 px-3 bg-faded d-block rounded-bottom text-right border-faded border-bottom-0 border-right-0 border-left-0">
                        <a href="/profile" class="fs-xs fw-500 ml-auto">Перейти до кабінету</a>
                    </div>
                </div>

            </b-dropdown-form>
        </b-dropdown>
    </div>

</template>

<script>

    import {mapGetters} from "vuex";
    import {createHelpers} from 'vuex-map-fields';
    const {mapFieldsUser} = createHelpers({
        getterType: 'user/getUserField',
    });

    import birthday from "./notification/birthday";
    import feed from "./notification/feed";
    import message from "./notification/message";

    export default {
        name: "user_app_notification",

        components : {
            birthday,
            feed,
            message
        },

        data() {
            return {
                tabs: [
                    {
                        "name" : "ДР",
                        "id" : 3,
                        type : "birthday"
                    },
                    {
                        "name" : "Повідомлення",
                        "id" : 1,
                        type : "message"
                    },
                    {
                        "name" : "Feed",
                        "id" : 2,
                        type : "feed"
                    },

                ],
                active_tab : {
                    "id" : 0
                },
                cur_page : 1,
            }
        },

        methods : {
            activate_tab(tab) {
                this.active_tab = tab;
            },


        },

        computed: {

            is_active_empty() {
                if(this.active_tab.id > 0) {
                    return false;
                }

                return true;
            },
            ...mapGetters({
                'user': "user/getUser",
            }),

        }
    }
</script>

<style scoped>
    .notif_user {
        min-width:350px;
    }
</style>
